import useWindowDimensions from "@/hooks/useWindowDimensions"
import { DeviceSize } from "@/types";
import { useMemo } from "react"

/**
 * A background component that generates random boxes for visual effect.
 */

type Box = {
    width: number
    height: number
    x: number
    y: number
    rot?: number
}

export const Background = () => {
    
    /*const {
        width,
        height,
        deviceSize
    } = useWindowDimensions()

    const boxCount = deviceSize === DeviceSize.SM ? 3 : deviceSize === DeviceSize.MD ? 5 : 7*/

    /*const boxes = useMemo(() => {
        const tempBoxes: Box[] = []
        for (let i = 0; i < boxCount; i++) {
            const w = Math.floor(Math.random() * width! * 0.2 + 20)
            const h = Math.floor(Math.random() * height! * 0.2 + 20)
            const x = Math.floor(Math.random() * (width! - w))
            const y = Math.floor(Math.random() * (height! - h))
            const rot = Math.floor(Math.random() * 360)
            tempBoxes.push({ width: w, height: h, x, y, rot })
        }
        return tempBoxes
    }, [boxCount, width, height])*/

    /*const renderBox = (box: Box, index: number) => {
        return (
            <div
                key={index}
                className={`absolute w-72 h-96 rounded-md shadow-2xl ${index % 2 === 0 ? 'shadow-[#ff914d] bg-[#ff914d]' : 'shadow-[#8c52ff] bg-[#8c52ff]'} opacity-20`}
                style={{
                    left: `${box.x}px`,
                    top: `${box.y}px`,
                    transform: `rotate(${box.rot}deg)`,
                }}
            ></div>
        )
    }*/

    return (
        <div className={`
            absolute
            top-0
            left-0
            right-0
            bottom-0
            overflow-hidden
            -z-20
            app-background
        `}>
            {/* Simply hide boxes for now. */}
            {/*boxes.map((box, index) => renderBox(box, index)*/}
        </div>
    )
}
export default Background

